import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client/react';
import { Box, Button, Dialog, Heading, HStack, Spinner, VStack } from '@chakra-ui/react';
import { useToast } from '@src/components/chakra-ui/use-toast';
import { AutoResizeTextarea } from '@src/components/sco/AutoResizeTextarea';
import { CreateFlagInput } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { useRef, useState } from 'react';
type CommentFlaggerProps = {
  commentId: string;
  isOpen: boolean;
  onClose: () => any;
};
export const CommentFlagger = props => {
  const $ = _c(32);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = CommentFlagger.mutations.deleteComment();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [createFlag, createFlagMutation] = useMutation(t0);
  const toast = useToast();
  const cancelRef = useRef(null);
  const [reason, setReason] = useState("");
  const onClose = props.onClose || _temp;
  let t1;
  if ($[1] !== createFlag || $[2] !== onClose || $[3] !== props.commentId || $[4] !== reason || $[5] !== toast) {
    t1 = async () => {
      await createFlag({
        variables: {
          input: {
            commentId: props.commentId,
            reason
          } as unknown as CreateFlagInput
        }
      });
      toast({
        title: "Thank you. The comment has been reported.",
        isClosable: true,
        status: "info",
        containerStyle: {
          color: "black"
        }
      });
      onClose();
    };
    $[1] = createFlag;
    $[2] = onClose;
    $[3] = props.commentId;
    $[4] = reason;
    $[5] = toast;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const onDelete = t1;
  let t2;
  if ($[7] !== onClose) {
    t2 = e => {
      if (!e.open) {
        onClose();
      }
    };
    $[7] = onClose;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Dialog.Backdrop />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Heading as="h4">Report this Comment</Heading>;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <label>Please explain why you are reporting this comment.</label>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ev => setReason(ev.currentTarget.value);
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== reason) {
    t7 = <Box>{t5}<AutoResizeTextarea marginTop="0.25em" minHeight="3em" placeholder="Spam, offensive, etc" value={reason} onChange={t6} /></Box>;
    $[13] = reason;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onClose) {
    t8 = <Button ref={cancelRef} size="sm" variant="outline" onClick={onClose}>Cancel</Button>;
    $[15] = onClose;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== createFlagMutation.loading) {
    t9 = createFlagMutation.loading ? <Spinner /> : "Submit Report";
    $[17] = createFlagMutation.loading;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== onDelete || $[20] !== t9) {
    t10 = <Button bgColor="red.600" size="sm" onClick={onDelete}>{t9}</Button>;
    $[19] = onDelete;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <HStack justify="flex-end">{t8}{t10}</HStack>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t7) {
    t12 = <Dialog.Positioner><Dialog.Content bgColor="colorPalette.container" padding="2em"><Dialog.Body><VStack align="stretch" gap="1em" justify="stretch" width="full">{t4}{t7}{t11}</VStack></Dialog.Body></Dialog.Content></Dialog.Positioner>;
    $[25] = t11;
    $[26] = t7;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== props.isOpen || $[29] !== t12 || $[30] !== t2) {
    t13 = <Dialog.Root open={props.isOpen} onOpenChange={t2}>{t3}{t12}</Dialog.Root>;
    $[28] = props.isOpen;
    $[29] = t12;
    $[30] = t2;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
CommentFlagger.mutations = {
  deleteComment: () => gql`
    mutation ($input: CreateFlagInput!) {
      createFlag(input: $input) {
        flag {
          id
        }
      }
    }
  `
};
function _temp() {
  return null;
}